/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/*
 * styleableimage.ts
 * 10-5-2024 - Jelmer Jellema - Spin in het Web B.V.
 *
 * Een extension van het standaard image format in Quill, zodat styles opgeslagen kunnen worden.
 *
 * Gebruik:
 *   Quill.register(StyleableImageFormat, true);
 */

import Quill from "quill";

const BaseImageFormat: any = Quill.import('formats/image');

export class StyleableImageFormat extends BaseImageFormat {
  domNode: any;
  private static readonly attributesWhitelist = ['alt', 'height', 'width', 'style'];

  static formats(domNode: HTMLElement) {
    const formats: any = {};
    for (let attribute of this.attributesWhitelist) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
    }
    return formats;
  }

  format(name: string, value: any) {
    if (StyleableImageFormat.attributesWhitelist.includes(name)) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}
